import { wsService } from "./wsService";

const section = "ajuste-manual";

const TYPE_POSITIVO = "P";
const TYPE_NEGATIVO = "N";

const TYPE_NAME_POSITIVO = "Positivo";
const TYPE_NAME_NEGATIVO = "Negativo";

function getAjusteTypeName(ajuste_type) {
  const typeMap = {
    [TYPE_POSITIVO]: TYPE_NAME_POSITIVO,
    [TYPE_NEGATIVO]: TYPE_NAME_NEGATIVO,
  };
  return typeMap[ajuste_type] || "";
}

function list_historial(param = { enable: true }) {
  return wsService.make_post_request(section + "/list-historial", param);
}

function list_assigned_locations(param = { enable: true }) {
  return wsService.make_post_request(section + "/list-assigned-locations", param);
}

function performe_ajuste(param = { enable: true }) {
  return wsService.make_post_request(section + "/performe-ajuste", param);
}

function download_excel(param = {}) {
  return wsService.make_post_request(section + "/get-sample-excel", param);
}

function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

export const historialAjusteService = {
  section,
  TYPE_POSITIVO,
  TYPE_NEGATIVO,
  TYPE_NAME_POSITIVO,
  TYPE_NAME_NEGATIVO,
  getAjusteTypeName,
  list_historial,
  list_assigned_locations,
  performe_ajuste,
  download_excel,
  import_line_excel
};
